const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const AboutTimeService = {
    async aboutTime(apiToCall: string): Promise<number> {
        const response = await fetch('/Api/AboutTime/AboutTime', {
            method: 'POST',
            body: JSON.stringify(apiToCall),
            headers,
        });
        return await response.json();
    },
};
